import MenuCategory from "./Common/MenuCategory";
import MenuItem from "./MenuItem";
import {borderRadius, buttonColors, fontsSize, plainColors} from "./UIElements/Elements";
import {useState} from "react";
import { faReceipt } from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";


const MenuItemsSideBar = ({onAddToOrder, totalSum}) => {

    const menuItems = [
        // Drinks
        {
            product_category_id: "43231cf7-3470-4437-89fb-28dbf70bed58",
            product_id: "a1b2c3d4-e5f6-7890-ab12-cd34ef56gh78",
            product_name: "Coca Cola",
            price: 70
        },
        {
            product_category_id: "43231cf7-3470-4437-89fb-28dbf70bed58",
            product_id: "b2c3d4e5-f678-90ab-12cd-34ef56gh7890",
            product_name: "Sprite",
            price: 60
        },
        {
            product_category_id: "43231cf7-3470-4437-89fb-28dbf70bed58",
            product_id: "c3d4e5f6-7890-ab12-cd34-ef56gh789012",
            product_name: "Pepsi",
            price: 60
        },
        {
            product_category_id: "43231cf7-3470-4437-89fb-28dbf70bed58",
            product_id: "b3c3d4e5-f678-90ab-12cd-34ef56gh7890",
            product_name: "Sprite",
            price: 60
        },
        {
            product_category_id: "43231cf7-3470-4437-89fb-28dbf70bed58",
            product_id: "c4d4e5f6-7890-ab12-cd34-ef56gh789012",
            product_name: "Pepsi",
            price: 60
        },

        // Appetizers
        {
            product_category_id: "76321e6c-6648-4d4e-ba9b-8f9d6f304f4a",
            product_id: "appetizer-001",
            product_name: "Garlic Bread",
            price: 80
        },
        {
            product_category_id: "76321e6c-6648-4d4e-ba9b-8f9d6f304f4a",
            product_id: "appetizer-002",
            product_name: "Mozzarella Sticks",
            price: 120
        },
        {
            product_category_id: "76321e6c-6648-4d4e-ba9b-8f9d6f304f4a",
            product_id: "appetizer-003",
            product_name: "Chicken Wings",
            price: 150
        },

        // Salads
        {
            product_category_id: "d77df705-f9e1-408f-a74a-678a79de1b5b",
            product_id: "salad-001",
            product_name: "Caesar Salad",
            price: 130
        },
        {
            product_category_id: "d77df705-f9e1-408f-a74a-678a79de1b5b",
            product_id: "salad-002",
            product_name: "Greek Salad",
            price: 140
        },
        {
            product_category_id: "d77df705-f9e1-408f-a74a-678a79de1b5b",
            product_id: "salad-003",
            product_name: "Tuna Salad",
            price: 160
        },

        // Main Meals
        {
            product_category_id: "913f30b8-3b6a-4923-a4bc-edbbed31feed",
            product_id: "main-001",
            product_name: "Grilled Chicken",
            price: 250
        },
        {
            product_category_id: "913f30b8-3b6a-4923-a4bc-edbbed31feed",
            product_id: "main-002",
            product_name: "Beef Steak",
            price: 350
        },
        {
            product_category_id: "913f30b8-3b6a-4923-a4bc-edbbed31feed",
            product_id: "main-003",
            product_name: "Spaghetti Bolognese",
            price: 200
        },

        // Pizzas
        {
            product_category_id: "a66b4ceb-388c-485a-b25e-2d57411ba6af",
            product_id: "pizza-001",
            product_name: "Margherita Pizza",
            price: 180
        },
        {
            product_category_id: "a66b4ceb-388c-485a-b25e-2d57411ba6af",
            product_id: "pizza-002",
            product_name: "Pepperoni Pizza",
            price: 220
        },
        {
            product_category_id: "a66b4ceb-388c-485a-b25e-2d57411ba6af",
            product_id: "pizza-003",
            product_name: "BBQ Chicken Pizza",
            price: 240
        }
    ];

    const menuCategories = [
        {
            id: "43231cf7-3470-4437-89fb-28dbf70bed58",
            category_name: "Drinks",
            kot_station_id: "",
        },
        {
            id: "76321e6c-6648-4d4e-ba9b-8f9d6f304f4a",
            category_name: "Appetizers",
            kot_station_id: "",
        },
        {
            id: "d77df705-f9e1-408f-a74a-678a79de1b5b",
            category_name: "Salads",
            kot_station_id: "",
        },
        {
            id: "913f30b8-3b6a-4923-a4bc-edbbed31feed",
            category_name: "Main Meals",
            kot_station_id: "",
        },
        {
            id: "a66b4ceb-388c-485a-b25e-2d57411ba6af",
            category_name: "Pizzas",
            kot_station_id: "",
        }
    ];
    const [activeCategoryId, setActiveCategoryId] = useState(menuCategories.length > 0 ? menuCategories[0].id : null);
    const [itemsToShow, setItemsToShow] = useState(menuItems.filter(item => item.product_category_id === activeCategoryId));
    const handleCategoryClick = (categoryId) => {
        setActiveCategoryId(categoryId);
        setItemsToShow(menuItems.filter(item => item.product_category_id === categoryId));
    };
    return (
        <div
            className={'fixed w-[73%] h-[92vh] top-[8vh] right-0  flex flex-col justify-start items-center pb-[2vh] max-lg:w-[100vw] max-lg:h-[52vh]'}>
            <div
                className={'w-[100%] h-auto  flex flex-wrap bg-teal-50 justify-start items-start content-start p-[1vh] max-lg:max-h-[12vh]'}>
                {menuCategories.map((item, index) => (
                    <MenuCategory
                        key={item.id}
                        categoryName={item.category_name}
                        isActive={activeCategoryId === item.id}
                        onClick={() => handleCategoryClick(item.id)}
                    />
                ))}
            </div>
            <div
                className={'w-[100%] h-[70vh] flex flex-wrap justify-start items-start content-start p-[0.5vw] border-t-[1vh] overflow-scroll hide-scrollbar max-lg:h-[40vh]'}>
                {itemsToShow.map((item, index) => (
                    <MenuItem
                        key={item.id}
                        id={item.id}
                        productId={item.product_id}
                        productName={item.product_name}
                        price={(item.price).toLocaleString()}
                        onClick={() => onAddToOrder(item.id, item.product_name, item.product_id, item.price, activeCategoryId)}
                    />
                ))}

            </div>
            <div className={'w-[100%] h-[12vh] bottom-0 flex justify-end items-center p-[1vh] max-lg:h-[8vh] max-lg:p-2 max-lg:justify-start max-lg:fixed max-lg:bottom-0 '}>
                <div
                    className={`w-[50%] h-[100%] ${buttonColors.secondary} p-[1vh] ${borderRadius.medium} cursor-pointer
                    max-lg:w-[50%]`}>
                    <div className={'w-[100%] h-[100%] p-[1vh] flex justify-center items-center'}>
                        <div className={`${fontsSize.l}`}><FontAwesomeIcon icon={faReceipt}/>&nbsp;Total&nbsp;</div>
                        <div className={`${fontsSize.l} font-bold`}>{Number(totalSum).toLocaleString()} <b className={`${fontsSize.m}`}>den</b>
                        </div>
                    </div>
                </div>

                &nbsp;
                <div
                    className={`w-[50%] h-[100%] ${plainColors.success} p-[1vh] ${borderRadius.medium} cursor-pointer max-lg:w-[50%]`}>
                    <div className={'w-[100%] h-[100%] p-[1vh] flex flex-col justify-center items-center'}>
                        <div className={`${fontsSize.l} font-medium`}>Order</div>
                    </div>
                </div>
            </div>

        </div>
    );
};


export default MenuItemsSideBar;